var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreamlineIconFruitApple({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.509a3.053 3.053 0 0 1-1.537-.277c-6.747-3.983-7.982 2.828-7.3 7.027.764 4.67 2.744 8.609 5.474 8.973a1.351 1.351 0 0 0 .785-.162l1.916-.975a1.441 1.441 0 0 1 1.316 0l1.916.975a1.351 1.351 0 0 0 .785.162c2.73-.364 4.71-4.3 5.474-8.973.371-2.259.186-5.273-1.115-6.959m-1.165-2.716a5.1 5.1 0 0 1-2.56 1.308.924.924 0 0 1-1.162-1.184A5.253 5.253 0 0 1 16.111 2.1a5.086 5.086 0 0 1 2.56-1.309.925.925 0 0 1 1.162 1.184 5.264 5.264 0 0 1-1.284 2.609ZM12 3.759v3.75",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconFruitApple);
export default __webpack_public_path__ + "static/media/streamline-icon-fruit-apple.72090a70.svg";
export { ForwardRef as ReactComponent };